/**
 * Absolute URL for files in /public (copied to the build root).
 * Respects import.meta.env.BASE_URL (e.g. /portfolio/ on GitHub Project Pages).
 * @param {string} path - e.g. "images/a.png" or "/images/a.png"
 */
export function publicUrl(path) {
  const stripped = path.replace(/^\//, '')
  const base = import.meta.env.BASE_URL || '/'
  const normalizedBase = base.endsWith('/') ? base : `${base}/`
  return `${normalizedBase}${stripped}`
}
